<template>
  <div>
    <div class="labels clearfix">
      <div v-if="!!hasTag">
        <div class="label-img-wrap" v-for="(item, index) in data" :key="index">
          <div v-if="item.mktFrontType === 400001" class="coupon-showTag">
            <!-- <img :src="require('../assets/imgs/coupons@2x.png')" alt="" /> -->
            <span class="coupon-showTag-type">券</span>
            <div class="coupon-showTag-info">{{ item.mktText }}</div>
          </div>
          <span v-else-if="item.mktFrontType === 2001" class="label-img">
            {{ item.rulesDtos && item.rulesDtos.length > 0 ? getStrPrice(item.rulesDtos[0].assembleRuleDesc, unionScale) : getStrPrice(item.mktText, unionScale) }}
          </span>
          <span
            class="label-img-tag"
            v-else-if="
              (item.type == 1 && item.mktFrontType != 2001 && item.mktFrontType != 600001) || item.type == 3 || item.mktFrontType === 9003 || item.mktFrontType === 9004 || item.mktFrontType === 9007 || item.mktFrontType === 300001
            "
          >
            <SingleTag :datas="item" />
          </span>
        </div>
      </div>

      <div class="label-img-wrap" v-if="unDelivery">
        <span class="cus-single-tag">部分街道可配</span>
      </div>
    </div>
    <div class="guideLabels" v-if="!!hasGuideTags">
      <div v-for="(item, index) in data" :key="index + 'guide'" class="guideLabels-wrap">
        <span
            class="label-img-tag"
            v-if="
              item.mktFrontType === 90061 || item.mktFrontType === 90062
            "
          >
            <SingleTag :datas="item" />
          </span>
      </div>
    </div>
  </div>
</template>
<script>
import { replacePrice } from '../utils';
import SingleTag from './SingleTag';

export default {
  components: {
    SingleTag,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    unDelivery: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    hasTag: function () {
      /**是否有可显示的标签*/
      let nTag = false;
      if (this.data && this.data.length > 0) {
        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i];
          if (
            item.mktFrontType === 400001 ||
            item.mktFrontType === 2001 ||
            (item.type == 1 && item.mktFrontType != 2001 && item.mktFrontType != 600001) ||
            item.type == 3 ||
            item.mktFrontType === 9003 ||
            item.mktFrontType === 9004 ||
            item.mktFrontType === 9007 ||
            item.mktFrontType === 300001
          ) {
            nTag = true;
            break;
          }
        }
      }
      return nTag;
    },
    hasGuideTags: function () {
      /**是否有可显示的导购标签*/
      let nTag = false;
      if (this.data && this.data.length > 0) {
        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i];
          if (
            item.mktFrontType === 90061 ||
            item.mktFrontType === 90062
          ) {
            nTag = true;
            break;
          }
        }
      }
      return nTag;
    },
  },
  data() {
    return {
      unionScale: window.union_scale || 1,
    };
  },
  methods: {
    getStrPrice(str, unionScale) {
      return replacePrice(str, unionScale);
    },
  },
};
</script>
<style lang="less" scoped>
@375: 320/375;
.labels {
  margin-top: 4px * @375;
  display: flex;
  flex-wrap: wrap;
  max-height: 42px * @375;
  overflow: hidden;
}
.label-img-wrap {
  float: left;
  margin-bottom: 3px;
  max-width: 100%;
  line-height: 0;
}
.label-img {
  margin-right: 2px * @375;
  width: 32px;
  height: 16px;
  font-size: 0;
  float: left;
  // margin-bottom: 1px;
}
.label-img-wrap:nth-child(1) .label-img {
  margin-left: 0;
}
.cus-single-tag {
  margin-bottom: 3px;
  font-size: 12px * @375;
  color: #666666;
  border: 1px * @375 solid #999999;
  line-height: 1;
  padding: 1.5px * @375 2px * @375 1px * @375;
  border-radius: 2px * @375;
  box-sizing: border-box;
  text-align: center;
  width: auto;
  height: auto;
  display: block;
  margin-right: 2px * @375;
}
span.label-img {
  color: #ff6600;
  width: auto;
  // height: 14px;
  height: auto;
  padding: 1.5px * @375 2px * @375 1px * @375;
  text-align: center;
  line-height: 1;
  font-size: 12px * @375;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  border-radius: 2px * @375;
  box-sizing: border-box;
}
span.label-img-tag {
  padding: 0;
  margin: 0;
  width: auto;
  height: auto;
  border: none;
  box-sizing: border-box;
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: ' ';
  display: block;
  height: 0;
  font-size: 0;
  clear: both;
  visibility: hidden;
}
.coupon-showTag {
  display: flex;
  // height: 16px * @375;
  height: auto;
  align-items: center;
  margin-right: 2px * @375;
}
.coupon-showTag > img {
  width: 16px * @375;
  height: 16px * @375;
  vertical-align: super;
  float: left;
}
.coupon-showTag-type {
  width: 16px * @375;
  // height: 16px * @375;
  height: auto;
  background: #ff6600;
  border-radius: 2px * @375 0px 0px 2px * @375;
  text-align: center;
  font-size: 12px * @375;
  color: #fff;
  // line-height: 15.5px * @375;
  line-height: 1;
  box-sizing: border-box;
  padding: 1.5px * @375 1px * @375 1px * @375;
  border: 1px * @375 #ff6600 solid;
  // border: none;
  flex-shrink: 0;
}
.coupon-showTag-info {
  border: 1px * @375 #ff6600 solid;
  border-left: none;
  border-top-right-radius: 2px * @375;
  border-bottom-right-radius: 2px * @375;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;

  // height: 16px * @375;
  height: auto;
  font-size: 12px * @375;
  font-weight: 400;
  color: #ff6600;
  // line-height: 16px * @375;
  line-height: 1;
  padding: 1.5px * @375 2px * @375 1px * @375;
  text-align: left;
  // float: left;
}
.guideLabels {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2px * @375;
  .guideLabels-wrap {
    width: auto;
    max-width: 100%;
  }
}
</style>
